<template>
  <header class="header">
    <nav class="nav-list">
      <div class="nav-item" v-for="nav in navList" :key="nav.title" :class="{active: activePage === nav.name}">
        <router-link :to="nav.route">
          <div class="nav-name" :data-nav="nav.title" :class="{new: newItem === nav.title}">
            {{nav.title}}
            <span v-if="newItem === nav.title" class="new-mark"></span>
          </div>
        </router-link>
      </div>
    </nav>
    <div class="logo">
      <router-link to="/">
        <img src="https://static.gabia.com/fonts/project/image/logo.svg" alt="글꼴프로젝트">
      </router-link>
    </div>
    <div class="licence" @mouseenter="showCursor" @mouseleave="showCursor(false)" @click="showLicence = true">
      <template v-if="overCursor">
        <svgButton />
      </template>
      <div class="h-button"><i class="fal fa-copyright"></i></div>
    </div>
    <a class="gabia-link" href="https://www.gabia.com" target="_blank">
      <div class="link">
        <div class="link-text-hover">
          <svg xmlns="http://www.w3.org/2000/svg" width="10.243" height="10.467" viewBox="0 0 10.243 10.467">
            <g id="그룹_158423" data-name="그룹 158423" transform="translate(-1778.257 -1680.5)">
              <rect id="사각형_53168" data-name="사각형 53168" width="1" height="9" rx="0.5" transform="translate(1788 1681) rotate(90)" stroke="#000" stroke-width="1"/>
              <rect id="사각형_53169" data-name="사각형 53169" width="1" height="9" rx="0.5" transform="translate(1788 1690) rotate(180)" stroke="#000" stroke-width="1"/>
              <rect id="사각형_53170" data-name="사각형 53170" width="1" height="11" rx="0.5" transform="translate(1779.671 1690.26) rotate(-135)" stroke="#000" stroke-width="1"/>
            </g>
          </svg>
          <span class="name">가비아</span>
        </div>
        <div class="link-text">
          <svg xmlns="http://www.w3.org/2000/svg" width="9.036" height="9.26" viewBox="0 0 9.036 9.26">
            <g id="그룹_158374" data-name="그룹 158374" transform="translate(-1778.964 -1681)">
              <rect id="사각형_53168" data-name="사각형 53168" width="1" height="9" rx="0.5" transform="translate(1788 1681) rotate(90)"/>
              <rect id="사각형_53169" data-name="사각형 53169" width="1" height="9" rx="0.5" transform="translate(1788 1690) rotate(180)"/>
              <rect id="사각형_53170" data-name="사각형 53170" width="1" height="11" rx="0.5" transform="translate(1779.671 1690.26) rotate(-135)"/>
            </g>
          </svg>
          <span class="name">가비아</span>
        </div>
      </div>
    </a>
    <div v-if="showLicence" class="modal-wrapper">
      <div class="modal-close" @click="showLicence = false"></div>
      <LicencePage />
    </div>
  </header>
</template>

<script>
import LicencePage from '@/components/LicencePage.vue';
import svgButton from '@/components/svgButton.vue';

export default {
  name: 'Header',
  components: { LicencePage, svgButton },
  data() {
    return {
      overCursor: false,
      // navList: ['2014', '2021', '글꼴 내려받기'],
      navList: [
        { name: 'Font2015', title: '2015', route: '2015' },
        { name: 'Font2022', title: '2022', route: '2022' },
        { name: 'Font2023', title: '2023', route: '2023' },
        { name: 'Font2024', title: '2024', route: '2024' },
        { name: 'FontStore', title: '글꼴 내려받기', route: 'download' },
      ],
      newItem: '2024',
      activePage: '',
      showLicence: false,
      licenceMenu: [
        { name: 'prints', title: '인쇄물' },
        { name: 'ci_bi', title: 'C.I/B.I' },
        { name: 'web_site', title: '웹사이트' },
        { name: 'video', title: '영상' },
        { name: 'device', title: '디바이스' },
        { name: 'server', title: '서버' },
        { name: 'e_book', title: 'E-book' },
        { name: 'etc', title: '기타' },
      ],
    };
  },
  watch: {
    $route() {
      this.activePage = this.$route.name;
    },
  },
  methods: {
    showCursor(value = true) {
      this.overCursor = value;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  nav.nav-list {
    position: absolute;
    top:0;
    left: 0;
    margin: 40px;
    display: flex;
    overflow: hidden;
    transition: all 500ms ease;
    .nav-item {
      margin-right: 40px;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: calc(100% + 10px);
        width: 27px;
        border-top: 1px solid #000;
      }
      &:last-child {
        margin: 0;
      }
      .nav-name {
        font-size: 18px;
        cursor: pointer;
        padding: 0 20px;
        position: relative;
        transition: transform 500ms ease;
        &:before {
          content: attr(data-nav);
          position: absolute;
          bottom: 100%;
          font-weight: 900;
        }
        &:hover {
          transform: translate3d(0, 100%, 0);
        }
        &.new::after {
          content: '';
          position: absolute;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          top: calc(-100% + 2px);
          right: 10px;
          background-color: #0A0A0A;
        }
      }
      &.active {
        .nav-name {
          transform: translate3d(0, 100%, 0);
        }
      }
      span.new-mark {
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        top: 2px;
        right: 12px;
        background-color: #0A0A0A;
      }
    }
  }
  .logo {
    margin: 40px auto;
  }
  .licence {
    position: absolute;
    top:0;
    right: 100px;
    padding: 40px;
    cursor: pointer;
    font-size: 20px;
    .container {
      position: absolute;
      width: 100px;
      height: 100px;
      top:0;
      right: 0;
    }
    .h-button {
      position: absolute;
      top: 40px;
      right: 40px;
    }
    &:hover {
      .fal {
        font-weight: bolder;
      }
    }
  }
  .gabia-link {
    position: absolute;
    top: 42px;
    right: 60px;
    width: 65px;
    cursor: pointer;
    .link {
      position: relative;
      overflow: hidden;
      &:hover {
        .link-text, .link-text-hover {
          transform: translate3d(0, 100%, 0);
        }
      }
      .link-text-hover {
        position: absolute;
        bottom: 100%;
        font-weight: 900;
      }
      .link-text, .link-text-hover {
        display: flex;
        align-items: center;
        gap: 10px;
        transition: transform 500ms ease;
      }
    }
  }
}
.modal-wrapper {
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: #f2f2f2;
  top: 0;
  left: 0;
  padding-top: 175px;
  overflow-y: auto;
  background: url("https://static.gabia.com/fonts/project/image/fold_pager_bg.png") no-repeat top center;
  background-size: cover;
  .modal-close {
    cursor: pointer;
    position: absolute;
    top: 80px;
    right: 20%;
    width: 36px;
    height: 36px;
    &:before, &:after {
      content: '';
      position: absolute;
      width: 2px;
      height: 38px;
      background-color: #0a0a0a;
      top:50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
}

</style>
